export function useBottomSheetFocusHook(): () => void {
  return () => {}
}
